import { makeStyles } from '@material-ui/core/styles';
import bio7 from '../../img/team-photo7.jpg';
import employeeSpotlight from '../../img/employee-spot.jpg';
import employeeSpotlightHover from '../../img/employee-spot-hover.jpg';


const careerClasses = makeStyles((theme) => ({
  nextPrevArrows: {
    justifyContent: 'center',
    display: 'flex',
  },

  containerSmall: {
    maxWidth: "80%",
    margin: "0 auto",
  },


  containerStepper: {
    maxWidth: "100%",
    margin: "0 auto",
    [theme.breakpoints.down('xs')]: {
      maxWidth: "100%",
    },
  },


  bioImage7: {
  backgroundImage:`url(${bio7})`,
  backgroundRepeat: 'no-repeat',
  backgroundColor:
    theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  display: 'flex',
  borderRadius: 30,
  minHeight: 500,
},

circleNumber: {
    display: 'flex',
    height: '30px',
    width: '30px',
    borderRadius: '60px',
    backgroundColor: 'transparent',
    border: "3px solid",
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 21,
    marginTop: "5px",
    marginBottom: "-10px",
    paddingTop: "4px",
    paddingLeft: "2px",
    paddingRight: "2px",
},

dividerSpotlight: {
  width: '75%',
  padding: 0,
  height: '2px',
  backgroundColor: "#D8F6EF",
  marginTop: 10,
  marginBottom: 10,
},

careerMargin: {
  marginBottom: 20,
},

careerBoxes: {
  marginBottom: 50,
  height: '100%',
},

namePadding: {
  marginTop: 20,
  padding: 0,
},

careersArrow: {
  paddingTop: 6,
  fontWeight: 600,
  display: 'flex',
},

viewButton: {
  marginTop: 0,
  [theme.breakpoints.down('sm')]: {
    marginTop: 10,
  },
},

tabLabels: {
  "& .MuiTab-wrapper": {
          fontSize:12,
        },
},

careerBio: {
  backgroundColor: '#555253',
  backgroundImage:`url(${employeeSpotlight})`,
  backgroundRepeat: 'no-repeat',
  height: 500,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  display: 'flex',
  borderRadius: 30,
},

careerBio2: {
  backgroundColor: '#333333',
  backgroundImage:`url(${employeeSpotlightHover})`,
  backgroundRepeat: 'no-repeat',
  height: 500,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  display: 'flex',
  borderRadius: 30,
},


careerListings: {
  paddingTop:30,
  paddingBottom: 30,
  margin: "0 auto",
  borderBottom: "1px solid white",
},


}));

export default careerClasses;